import { ChartIntervalTypes } from 'pages/index-details/storage/interface'
import moment from 'moment'
import { ChartPlot } from 'pages/portfolio/storage/interface'
import { PriceHistory } from 'services/query-v2/products/index/daily-statistics/model'
import { ChartIntervalSet, StateConfig } from '../config'
/**
 * Sorting function for sorting arr timelines by date
 */

export const byXAxis = (a: { x: string }, b: { x: string }) => {
  if (a.x < b.x) return -1
  if (a.x > b.x) return 1
  return 0
}

export const byLastTwoWeeks = (item: { x: string }) => {
  const { x } = item
  const dateModifier = new Date()
  dateModifier.setDate(dateModifier.getDate() - 90)
  const twoWeeksEpoch = Math.floor(dateModifier.getTime() / 1000)
  return Number(x) > twoWeeksEpoch
}

export const buildTimeSeriesFromPriceHistory = ({ date, basePrice }: PriceHistory): ChartPlot => {
  return {
    x: `${moment(date).unix()}`,
    y: basePrice.toString(),
  }
}

export const getTimeWindow = (interval: ChartIntervalTypes): StateConfig => {
  const result = ChartIntervalSet.find((e) => e.name === interval)
  if (!result) {
    throw new Error('Invalid interval')
  }
  return result
}
